/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlInvite } from './ControlInvite';
import {
    ControlInviteFromJSON,
    ControlInviteFromJSONTyped,
    ControlInviteToJSON,
} from './ControlInvite';

/**
 * 
 * @export
 * @interface Emails
 */
export interface Emails {
}

/**
 * Check if a given object implements the Emails interface.
 */
export function instanceOfEmails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailsFromJSON(json: any): Emails {
    return EmailsFromJSONTyped(json, false);
}

export function EmailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Emails {
    return json;
}

export function EmailsToJSON(value?: Emails | null): any {
    return value;
}

